<div class="pick-list-container">
	<div class="pick-list-header">
		<div class="descriptions-container">
			<h2 class="title">{{ field?.DisplayText }}</h2>
			<p class="description-label" *ngIf="field.description">{{field.description}}</p>
		</div>
		<button pButton icon="far fa-plus-circle" (click)="showNewItemDialog()" [disabled]="control.disabled" class="p-button-success new-table-element-button" label="New"></button>
	</div>

	<div class="pick-list-body">
		<p-table [value]="data"
				 [reorderableColumns]="(field.UIOptions.tableConfig?.isReorderable && !control.disabled) || false"
				 [tableStyle]="{'min-width': '50rem'}"
				 (onRowReorder)="updateData($event)"
				 styleClass="custom-field-table"
		>
			<ng-template
				*ngIf="field.UIOptions.tableConfig?.headerColumns && field.UIOptions.tableConfig.headerColumns.length > 0"
				pTemplate="header">
				<tr>
					<th style="width:3rem"></th>
					<th *ngFor="let col of field.UIOptions.tableConfig.headerColumns">
						{{ col }}
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-rowData let-index="rowIndex">
				<tr [pReorderableRow]="(!control.disabled && field.UIOptions.tableConfig?.isReorderable) ? index : -1">
					<td class="numeric-index" *ngIf="field.UIOptions.tableConfig?.hasCounterInfo">
						{{ index + 1 }}
					</td>
					<td class="order-button" *ngIf="!control.disabled && field.UIOptions.tableConfig?.isReorderable">
						<span class="pi pi-bars" [pReorderableRowHandle]="index"></span>
					</td>
					<td>
						{{ rowData }}
					</td>
					<td class="action-button">
						<button pButton pRipple type="button" [disabled]="control.disabled" (click)="removeElement(index)" icon="pi pi-trash"
								class="p-button-rounded p-button-danger delete-row-button"></button>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>
